import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { useNavigate } from "react-router";
import { Row, Col, Button, Form, Container } from "react-bootstrap";
import {
  Title,
  ContainerCupom,
  TitleBrand,
  Line,
  BoxSlider,
  CouponSuccess,
  CouponError,
  DiscountRow,
} from "./styles";
import TextField from "@mui/material/TextField";
import notify from "../../components/UI/toast";
import SliderCheckout from "../../components/SliderCheckout";
import { BrlFormatCurrency, FormatPoints, roundCurrency } from "../../lib";
import { LoaderSmall } from "../../components/Loader";
import PaymentMethods from "../../components/PaymentMethods";
import { useUserData } from "../../hooks/UserContext";
import TitleHead from "../../components/Title";
import Footer from "../../components/Footer";

import {
  FaRegCheckCircle,
  FaExclamationCircle,
  FaChevronDown,
} from "react-icons/fa";
import SliderCheckoutCoupon from "../../components/SliderCheckoutCoupon";

import { useSelector } from "react-redux";
import { cardsApi, pedidosApi, couponApi, clientesApi } from "./_services/api";
import { CouponRulesModal } from "./_components/CouponRulesModal";
import HotelTermsModal from "./_components/TermsModals/HotelTermsModal";
import AereoTermsModal from "./_components/TermsModals/AereoTermsModal";
import { removeItemCart } from "../../Redux/cartSlice";
import { useDispatch } from "react-redux";
import ProductRow from "./_components/Row/ProductRow";
import HotelSummary from "./_components/Summary/HotelSummary";
import AereoSummary from "./_components/Summary/AereoSummary";
import AereoPricingSummary from "./_components/Summary/AereoPricingSummary";
import { useApp } from "../../contexts/AppContext";
import { useLocation, useSearchParams } from "react-router-dom";
import { format, subDays, isAfter } from "date-fns";
import EmailRequiredModal from "components/GlobalModals/EmailRequiredModal";
import InsufficientPointsModal from "components/GlobalModals/InsufficientPointsModal";
import ModalApp from "../../components/ModalApp";
import {
  useCardManagement,
  AddCardModal,
} from "../../components/CardManagement";
import {
  trackHotelPayment,
  trackHotelCallback,
  trackFlightPayment,
  trackFlightTransaction,
} from "utils/analytics";
import {
  trackResumoCompraEvent,
  trackViewCartMarketplaceItems,
  trackAddShippingInfoMarketplaceItems,
  trackAddPaymentInfoMarketplaceItems,
  trackPurchaseMarketplaceItems,
  trackClick,
} from "utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import {
  getCustomerFromMemory,
  setCustomerInMemory,
} from "../../lib/sharedSessionMemory";
import {
  useFeatureFlag,
  usePaymentFlags,
} from "../../contexts/FeatureFlagProvider";
import {
  calculateHotelPoints,
  normalizeHotelCheckoutData,
  resolveEffectiveMoneyToPay,
} from "./_utils/travelCheckout";

export default function Product() {
  const [showEmailRequired, setShowEmailRequired] = useState(false);
  const [showInsufficientPoints, setShowInsufficientPoints] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingCheckout, setLoadingCheckout] = useState(false);
  const [loadingCoupon, setLoadingCoupon] = useState(false);
  const [cards, setCards] = useState([]);
  const [installmentsSelected, setInstallmentsSelected] = useState();
  const [installments, setInstallments] = useState([]);
  const [coupon, setCoupon] = useState("");
  const [errorCoupon, setErrorCoupon] = useState("");
  const [aplicouCupon, setAplicouCupon] = useState(false);
  const [sliderValue, setSliderValue] = useState(0);
  const [dinheiroValue, setDinheiroValue] = useState(0);
  const [pontosValue, setPontosValue] = useState(0);
  const [dataCheckout, setDataCheckout] = useState([]);
  const [itemsCart, setItemsCart] = useState([]);
  const [disableMoneyPayment, setDisableMoneyPayment] = useState("");
  const [refreshCards, setRefreshCards] = useState();
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [open, setOpen] = useState(false);
  const {
    user,
    addressShipping,
    setUpdateUser,
    mainCard,
    setMainCard,
    cartItemsError,
    setCartItemsError,
    updateUserData,
    userData,
    isPJ,
  } = useUserData();
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [isValidCoupon, setIsValidCoupon] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const screenName = useScreenTracking();
  const cardMgmt = useCardManagement({
    cards,
    setCards,
    setRefreshCards,
    addresses: user?.addresses,
  });
  const [rules, setRules] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [errorCode, setErrorCode] = useState("");
  const [isMoneyDisabled, setIsMoneyDisabled] = useState(false);
  const [rulesExpanded, setRulesExpanded] = useState(false);
  const [couponMoneyToPay, setCouponMoneyToPay] = useState(0);

  const [searchParams] = useSearchParams();
  const [isHotelCheckout, setIsHotelCheckout] = useState(false);
  const [isAereoCheckout, setIsAereoCheckout] = useState(false);
  const [envisionData, setEnvisionData] = useState(null);
  const [hotelTermsAccepted, setHotelTermsAccepted] = useState(false);
  const [hotelRulesModalOpen, setHotelRulesModalOpen] = useState(false);
  const [aereoTermsAccepted, setAereoTermsAccepted] = useState(false);
  const [aereoRulesModalOpen, setAereoRulesModalOpen] = useState(false);

  const { loading: loadingCart, payment_method } = useSelector(
    (state) => state.cartSlice,
  );

  const { whitelabel } = useApp();
  const [displayMode, setDisplayMode] = useState(
    whitelabel?.config?.payment_mode,
  );
  const couponsEnabled = useFeatureFlag("coupons");
  const paymentFlags = usePaymentFlags();

  const configData = whitelabel?.config || {};
  const channel = process.env.REACT_APP_DEFAULT_CHANNEL;
  const fatorFreteKey = `fator_${channel}_frete`;
  const fatorAirTicketKey = `fator_${channel}_aereo`;
  const fatorHotelKey = `fator_${channel}_hotel`;
  const fatorFrete = configData[fatorFreteKey] / 10000 || 0;
  const fatorAirTicket = configData[fatorAirTicketKey] / 10000 || 0;
  const fatorHotel = configData[fatorHotelKey] / 10000 || 0;
  const isCashOnly = displayMode === "money";
  const location = useLocation();
  const mainCardRef = useRef(mainCard);
  const cartEventsSent = useRef(false);

  const [minValue, setMinValue] = useState(
    Number(configData?.[`${channel}_min_value`]) || 0,
  );

  useEffect(() => {
    setDisplayMode(whitelabel?.config?.payment_mode);
  }, [whitelabel]);

  useEffect(() => {
    if (paymentFlags.points === false) {
      setDisplayMode("money");
    }
  }, [paymentFlags.points]);

  useEffect(() => {
    mainCardRef.current = mainCard;
  }, [mainCard]);

  const productPoints = useMemo(() => {
    return Math.round(
      dataCheckout.cart?.items?.reduce(
        (acc, item) =>
          acc + (item.price?.points?.offer || 0) * (item.quantity || 0),
        0,
      ) || 0,
    );
  }, [dataCheckout.cart?.items]);

  const shippingPoints = useMemo(() => {
    const summaryShippingPoints = parseFloat(
      dataCheckout.summary?.shippingPoints,
    );
    if (summaryShippingPoints > 0) {
      return Math.round(summaryShippingPoints);
    }

    const shippingBRL = parseFloat(dataCheckout.summary?.shipping) || 0;
    if (shippingBRL > 0 && fatorFrete > 0) {
      const factor = 1 / fatorFrete;
      return Math.round(shippingBRL * factor);
    }

    return 0;
  }, [
    dataCheckout.summary?.shippingPoints,
    dataCheckout.summary?.shipping,
    fatorFrete,
  ]);

  const totalPoints = useMemo(() => {
    return productPoints + shippingPoints;
  }, [productPoints, shippingPoints]);

  const discountInPoints = useMemo(() => {
    const discount = parseFloat(dataCheckout.summary?.discount) || 0;
    if (discount <= 0 || fatorFrete <= 0) {
      return 0;
    }
    const factor = 1 / fatorFrete;
    return Math.round(discount * factor);
  }, [dataCheckout.summary?.discount, fatorFrete]);

  const totalPointsWithDiscount = useMemo(() => {
    return Math.max(0, totalPoints - discountInPoints);
  }, [totalPoints, discountInPoints]);

  const ORDER_STATUS = Object.freeze({
    DENIED: "negado",
  });

  useEffect(() => {
    if (isPJ && !userData.data?.email) {
      setShowEmailRequired(true);
    }
  }, [userData, isPJ]);

  const hasEmail = useMemo(
    () => !!userData.data?.email,
    [userData.data?.email],
  );

  async function getCard() {
    try {
      if (!user?.cpf) {
        console.warn("User CPF not available, skipping card fetch");
        return [];
      }

      const { data, status } = await cardsApi.get(
        `/v1/customer/card`,
      );

      if (status !== 200) {
        notify("Erro ao obter os dados do cartão", "error");
        return [];
      }

      return data.data || [];
    } catch (err) {
      console.error(err);
      if (!isHotelCheckout) {
        notify("Erro ao obter os dados do cartão.", "error");
      }
      return [];
    }
  }

  async function getCheckout() {
    if (Object.keys(addressShipping).length === 0) {
      navigate("/loja/orderresume/", { replace: true });
      notify("Selecione o endereço de entrega.", "error");
      return;
    }

    const response = await pedidosApi.get(`v2/checkout/resumo/${channel}`, {
      params: {
        customerUuid: user.uuid,
        cep: addressShipping.cep || user.addresses[0].cep,
        fator: fatorFrete,
      },
    });
    return response.data;
  }

  function getEnvisionDataFromLocalStorage() {
    try {
      const envisionData = localStorage.getItem("envision");
      if (!envisionData) return null;
      const binaryString = atob(envisionData);
      const uint8Array = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }
      const decoded = new TextDecoder().decode(uint8Array);
      return JSON.parse(decoded);
    } catch (error) {
      return null;
    }
  }

  async function handleHotelCheckout(checkoutPayload) {
    const response = await pedidosApi.post(
      `v2/checkout/finalizar-pedido/${channel}`,
      checkoutPayload,
    );
    return response;
  }

  function getHotelRoom() {
    if (!envisionData?.hotel?.hotels?.[0]?.rooms?.[0]) return null;
    return envisionData.hotel.hotels[0].rooms[0];
  }

  function getHotel() {
    if (!envisionData?.hotel?.hotels?.[0]) return null;
    return envisionData.hotel.hotels[0];
  }

  function getCancellationPolicy() {
    const room = getHotelRoom();
    if (!room) return null;

    // Novas validações para irrevocableGuarantee e nonRefundable
    const resInfo = room.reservationInfo;
    
    const isIrrevocable = resInfo?.irrevocableGuarantee === true;
    
    const isNonRefundable = Array.isArray(resInfo?.cancellationPolicies) 
      ? resInfo.cancellationPolicies.some(policy => policy?.nonRefundable === true) 
      : false;
    
    if (isIrrevocable || isNonRefundable) {
      return {
        title: "Tarifa não reembolsável",
        text: "Em caso de cancelamento, o valor pago pela hospedagem não será reembolsável.",
        isFree: false,
      };
    }

    const cancelDeadline = room.reservationInfo?.cancelDeadLineDateValues;
    const today = new Date();
    let isFreeCancellation = false;
    let deadlineFormatted = "";

    if (cancelDeadline) {
      const deadlineDate = new Date(
        cancelDeadline.year,
        cancelDeadline.month - 1,
        cancelDeadline.day,
        cancelDeadline.hour,
        cancelDeadline.minutes,
      );
      const freeCancellationUntil = subDays(deadlineDate, 3);
      isFreeCancellation = isAfter(freeCancellationUntil, today);
      deadlineFormatted = format(freeCancellationUntil, "dd/MM");
    }

    if (isFreeCancellation) {
      return {
        title: `Cancelamento grátis até ${deadlineFormatted}`,
        text: `Em caso de cancelamento até ${deadlineFormatted}, o valor será reembolsável. Após essa data, não haverá reembolso.`,
        isFree: true,
      };
    }

    return {
      title: "Tarifa não reembolsável",
      text: "Em caso de cancelamento, o valor pago pela hospedagem não será reembolsado.",
      isFree: false,
    };
  }

  function getTravelDiscountBRL() {
    if (!isCouponApplied || !dataCheckout.summary?.coupon || !envisionData)
      return 0;

    let fareBase;
    if (isAereoCheckout) {
      const pricing = envisionData?.pricing || {};
      const totalFare = pricing.TotalFare || {};
      fareBase = Number(totalFare.TotalFare) + Number(totalFare.TotalFee) || 0;
    } else {
      const room = getHotelRoom();
      if (!room) return;
      const nights = getHotelNights();
      fareBase = Number(room.markedupDailyFare.value * nights);
    }

    const couponInfo = dataCheckout.summary.coupon;
    const minimumOrderValue = Number(couponInfo.value_minimum_order) || 0;
    const maxDiscountValue = couponInfo.discount_maximum_in_real ? Number(couponInfo.discount_maximum_in_real) : null;
    const allowZeroPurchase = couponInfo.allow_zero_purchase || false;
    if (fareBase < minimumOrderValue) {
      return 0;
    }

    let discountBRL = 0;

    if (couponInfo.discount_type === 1) {
      discountBRL = Number(couponInfo.discount_value) || 0;
    } else if (couponInfo.discount_type === 2) {
      const pct = Number(couponInfo.discount_value) / 100 || 0;
      discountBRL = fareBase * pct;

      if (maxDiscountValue !== null && discountBRL > maxDiscountValue) {
        discountBRL = maxDiscountValue;
      }
    }

    if (discountBRL > fareBase) {
      if (!allowZeroPurchase) {
        return 0;
      }
      discountBRL = fareBase;
    }

    return Math.max(0, Math.min(discountBRL, fareBase));
  }

  function getAereoTotalPoints() {
    const segments =
      envisionData?.choosenFlight?.segments || envisionData?.segments || {};
    const pricing = envisionData?.pricing || {};
    const totalFare = pricing.TotalFare || {};
    const fares = Array.isArray(segments.fares)
      ? segments.fares
      : Array.isArray(pricing.Fares)
        ? pricing.Fares
        : [];

    const computedTotal = fares.reduce((sum, f) => {
      const qty = Number(f?.Quantity) || 1;
      const fareAmount =
        Number(f?.FareAmount) || Number(f?.ForeignFareAmount) || 0;
      const taxesAmount = Number(f?.TaxesAmount) || 0;
      const feeAmount = Number(f?.FeeAmount) || 0;
      return sum + (fareAmount + taxesAmount + feeAmount) * qty;
    }, 0);

    const grandTotal =
      Number(totalFare.GrandTotal) ||
      Number(envisionData?.amount?.BRL) ||
      computedTotal ||
      0;
    const basePoints = fatorAirTicket > 0 ? grandTotal / fatorAirTicket : 0;

    const discountBRL = getTravelDiscountBRL();
    const discountInPoints =
      fatorAirTicket > 0 ? discountBRL / fatorAirTicket : 0;

    return Math.max(0, Math.ceil(basePoints - discountInPoints));
  }

  function getAereoTotalMoney() {
    const segments =
      envisionData?.choosenFlight?.segments || envisionData?.segments || {};
    const pricing = envisionData?.pricing || {};
    const totalFare = pricing.TotalFare || {};
    const fares = Array.isArray(segments.fares)
      ? segments.fares
      : Array.isArray(pricing.Fares)
        ? pricing.Fares
        : [];

    const computedTotal = fares.reduce((sum, f) => {
      const qty = Number(f?.Quantity) || 1;
      const fareAmount =
        Number(f?.FareAmount) || Number(f?.ForeignFareAmount) || 0;
      const taxesAmount = Number(f?.TaxesAmount) || 0;
      const feeAmount = Number(f?.FeeAmount) || 0;
      return sum + (fareAmount + taxesAmount + feeAmount) * qty;
    }, 0);

    const grandTotal =
      Number(envisionData?.amount?.BRL) ||
      Number(totalFare.GrandTotal) ||
      Number(totalFare.Total) ||
      computedTotal ||
      0;

    const discountBRL = getTravelDiscountBRL();

    return Math.max(0, grandTotal - discountBRL);
  }

  function getHotelNights() {
    const room = getHotelRoom();
    if (!room?.checkIn || !room?.checkOut) return 1;

    const checkIn = new Date(
      room.checkIn.year,
      room.checkIn.month - 1,
      room.checkIn.day,
    );
    const checkOut = new Date(
      room.checkOut.year,
      room.checkOut.month - 1,
      room.checkOut.day,
    );
    const diffTime = checkOut.getTime() - checkIn.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 1;
  }

  function getHotelDailyPoints() {
    const room = getHotelRoom();
    return calculateHotelPoints(room, getHotelNights(), fatorHotel).daily;
  }

  function getHotelTaxPoints() {
    const room = getHotelRoom();
    return calculateHotelPoints(room, getHotelNights(), fatorHotel).tax;
  }

  function getHotelTotalPoints() {
    const grandTotal = getHotelDailyPoints() + getHotelTaxPoints();

    const discountBRL = getTravelDiscountBRL();
    const discountInPoints = Math.ceil(
      fatorHotel > 0 ? discountBRL / fatorHotel : 0
    );

    return Math.max(0, Math.ceil(grandTotal - discountInPoints));
  }

  function getHotelTotalMoney() {
    const room = getHotelRoom();
    if (!room) return 0;
    const nights = getHotelNights();

    const totalDailyFare = room.markedupDailyFare.value * nights;
    const totalDailyTax = room.dailyTax.value * nights;
    const grandTotal = totalDailyFare + totalDailyTax;

    const discountBRL = getTravelDiscountBRL();

    return Math.max(0, grandTotal - discountBRL);
  }

  function getHotelDailyMoney() {
    const room = getHotelRoom();
    if (!room) return 0;
    return (room.markedupDailyFare?.value || 0) * getHotelNights();
  }

  function getHotelTaxMoney() {
    const room = getHotelRoom();
    if (!room) return 0;
    return (room.dailyTax?.value || 0) * getHotelNights();
  }


  function formatHotelDate(dateObj) {
    if (!dateObj) return "";
    const day = String(dateObj.day).padStart(2, "0");
    const month = String(dateObj.month).padStart(2, "0");
    const year = dateObj.year;
    return `${day}/${month}/${year}`;
  }

  function buildCustomerAddress() {
    return {
      addressUuid: addressShipping.uuid,
      streetName: addressShipping.address_line1 || addressShipping.streetName,
      complement: addressShipping.address_line3 || addressShipping.complement,
      neighborhood:
        addressShipping.address_line2 || addressShipping.neighborhood,
      number: addressShipping.number,
      cep: addressShipping.cep || addressShipping.zipCode,
      city: addressShipping.city,
      state: addressShipping.state,
      reference: addressShipping.reference,
    };
  }

  const fetchAndProcessCartData = async () => {
    try {
      const response = await pedidosApi.get(
        `/v2/checkout/resumo/${channel}?customerUuid=${user.uuid}&cep=${addressShipping.cep}&fator=${fatorFrete}`,
      );
      const checkoutData = response.data.data;

      const { allItems, shippingByBrand } = processCartData(checkoutData.cart);

      const formattedCheckoutData = {
        ...checkoutData,
        cart: {
          ...checkoutData.cart,
          items: allItems,
          shipping_by_brand: shippingByBrand,
        },
      };

      return formattedCheckoutData;
    } catch (error) {
      console.error("Erro ao buscar dados do carrinho:", error);
      throw error;
    }
  };

  const processCartData = (cartData) => {
    const allItems = [];
    const shippingByBrand = {};

    if (cartData.items && Array.isArray(cartData.items)) {
      allItems.push(...cartData.items);

      if (dataCheckout.cart?.shipping_by_brand) {
        Object.assign(shippingByBrand, dataCheckout.cart.shipping_by_brand);
      }

      return { allItems, shippingByBrand };
    }

    Object.values(cartData || {}).forEach((cartInfo) => {
      if (cartInfo.items) {
        allItems.push(...cartInfo.items);

        cartInfo.items.forEach((item) => {
          const brandId = item.brand_uuid;
          if (!shippingByBrand[brandId]) {
            shippingByBrand[brandId] = {
              shipping_amount: cartInfo.deliveryOptions?.shippingPrice || 0,
              shipping_point: cartInfo.deliveryOptions?.shippingPoints || 0,
              shipping_deadline:
                cartInfo.deliveryOptions?.estimatedBusinessDays || 0,
              shipping_delivery_date:
                cartInfo.deliveryOptions?.estimatedDeliveryDate || null,
            };
          }
        });
      }
    });

    return { allItems, shippingByBrand };
  };

  async function setCartPedidosApi(items) {
    setCartItemsError({});
    if (addressShipping?.cep && user.uuid) {
      setLoading(true);

      try {
        const formattedCheckoutData = await fetchAndProcessCartData();

        setDataCheckout(formattedCheckoutData);

        const grouped = await groupItemsSeller(
          formattedCheckoutData.cart.items,
        );
        setItemsCart(grouped);
      } catch (error) {
        console.error("Erro em setCartPedidosApi:", error);
        notify("Erro ao carregar dados do carrinho", "error");
      } finally {
        setLoading(false);
      }
    }
  }

  function groupByKey(array, prop) {
    return array.reduce(function (items, item) {
      const key = item[prop];
      items[key] = (items[key] || []).concat(item);
      return items;
    }, {});
  }

  const groupItemsSeller = async (array) => {
    if (array) {
      const items = array.map((item) => ({
        ...item,
        seller: item?.seller,
        brand_uuid: item?.brand_uuid,
      }));
      return groupByKey(items, "seller");
    }
  };

  const getShippingPointsValue = () => {
    const summaryShippingPoints = parseFloat(
      dataCheckout?.summary?.shippingPoints,
    );
    if (summaryShippingPoints > 0) {
      return Math.round(summaryShippingPoints);
    }
    const shippingBRL = parseFloat(dataCheckout?.summary?.shipping) || 0;
    if (shippingBRL > 0 && fatorFrete > 0) {
      const factor = 1 / fatorFrete;
      return Math.round(shippingBRL * factor);
    }
    return 0;
  };

  function calcularMaxSliderValue() {
    if (!dataCheckout?.cart || !user?.balance?.data) return 100;

    const items = Array.isArray(dataCheckout.cart.items)
      ? dataCheckout.cart.items
      : [];

    const pontosBase = items.reduce(
      (acc, item) =>
        acc + (item?.price?.points?.offer ?? 0) * (item?.quantity ?? 0),
      0,
    );
    const shippingPts = getShippingPointsValue();
    const totalPoints = Math.round(pontosBase + shippingPts);

    if (totalPoints === 0) return 100;

    const balance = Math.trunc(user.balance.data);

    if (balance >= totalPoints) return 0;

    const maxPctDinheiro = ((totalPoints - balance) / totalPoints) * 100;

    return Math.min(Math.max(maxPctDinheiro, 0), 100);
  }

  function calcularMaxSliderValueForMinPoints() {
    if (!dataCheckout?.cart || !minValue || minValue <= 0) return 100;

    const items = Array.isArray(dataCheckout.cart.items)
      ? dataCheckout.cart.items
      : [];

    const pontosBase = items.reduce(
      (acc, item) =>
        acc + (item?.price?.points?.offer ?? 0) * (item?.quantity ?? 0),
      0,
    );
    const shippingPts = getShippingPointsValue();
    const totalPoints = Math.round(pontosBase + shippingPts);

    if (totalPoints === 0) return 100;

    if (minValue >= totalPoints) return 0;

    const maxSliderForMinPoints =
      ((totalPoints - minValue) / totalPoints) * 100;

    return Math.min(Math.max(maxSliderForMinPoints, 0), 100);
  }

  function getPaymentType(moneyValue, pointsValue) {
    if (moneyValue > 0 && pointsValue > 0) return "cartao-de-credito+pontos";
    if (moneyValue > 0) return "cartao-de-credito";
    return "pontos";
  }

  const paymentInfoTimer = useRef(null);
  function handlePaymentInfoChange(moneyValue, pointsValue) {
    if (isHotelCheckout || isAereoCheckout) return;

    if (paymentInfoTimer.current) clearTimeout(paymentInfoTimer.current);
    paymentInfoTimer.current = setTimeout(() => {
      trackAddPaymentInfoMarketplaceItems(
        dataCheckout.cart?.items || [],
        getPaymentType(moneyValue, pointsValue),
      );
    }, 500);
  }

  function handleSliderChange(event, newValue) {
    if (!dataCheckout?.cart) return;

    const maxSliderValueByBalance = calcularMaxSliderValue();

    const maxSliderValueByMinPoints = calcularMaxSliderValueForMinPoints();

    const maxSliderValue = Math.max(
      maxSliderValueByBalance,
      maxSliderValueByMinPoints,
    );

    if (newValue < maxSliderValueByBalance) {
      setSliderValue(maxSliderValueByBalance);
      calcularDinheiroPontos(maxSliderValueByBalance);

      const balance = Math.trunc(user?.balance?.data ?? 0);
      const balanceFormatted = balance.toLocaleString("pt-BR");
      notify(
        `Não é possível selecionar mais pontos. Você possui ${balanceFormatted} pontos disponíveis. O valor máximo foi ajustado automaticamente.`,
        "warning",
      );
      return;
    }

    if (newValue > maxSliderValueByMinPoints && minValue > 0) {
      setSliderValue(maxSliderValueByMinPoints);
      calcularDinheiroPontos(maxSliderValueByMinPoints);

      const MinValueFormatted = minValue.toLocaleString("pt-BR");
      notify(
        `É necessário selecionar pelo menos ${MinValueFormatted} pontos. O valor mínimo foi ajustado automaticamente.`,
        "warning",
      );
      return;
    }

    setSliderValue(newValue);
    calcularDinheiroPontos(newValue);
  }

  function calcularDinheiroPontos(range) {
    if (!dataCheckout?.cart) return;

    const items = Array.isArray(dataCheckout.cart.items)
      ? dataCheckout.cart.items
      : [];

    const pontosBase = items.reduce(
      (acc, item) =>
        acc + (item?.price?.points?.offer ?? 0) * (item?.quantity ?? 0),
      0,
    );
    const reaisBase = items.reduce(
      (acc, item) =>
        acc +
        (parseFloat(item?.price?.BRL?.offer ?? 0) || 0) * (item?.quantity ?? 0),
      0,
    );

    const shippingMoney = parseFloat(dataCheckout?.summary?.shipping) || 0;
    const shippingPts = getShippingPointsValue();
    const descontoMoney = parseFloat(dataCheckout?.summary?.discount) || 0;

    const reaisTotais = reaisBase + shippingMoney - descontoMoney;
    const pontosTotais = Math.round(pontosBase + shippingPts);

    const fracDinheiro = (Number(range) || 0) / 100;

    let dinheiroParcial = reaisTotais * fracDinheiro;
    let pontosParcial = pontosTotais * (1 - fracDinheiro);

    const balance = Math.trunc(user?.balance?.data ?? 0);

    if (pontosParcial > balance && pontosTotais > 0) {
      const pontosExcedentes = pontosParcial - balance;

      const taxaConversao = reaisTotais / pontosTotais;
      const reaisAdicionais = pontosExcedentes * taxaConversao;
      dinheiroParcial = dinheiroParcial + reaisAdicionais;
      pontosParcial = balance;
    }

    const wasEnforcedToMin =
      minValue > 0 && pontosParcial < minValue && pontosTotais >= minValue;
    if (wasEnforcedToMin) {
      pontosParcial = Math.min(minValue, pontosTotais);
      const taxaConversao = reaisTotais / pontosTotais;
      dinheiroParcial = (pontosTotais - pontosParcial) * taxaConversao;
    }

    if (!wasEnforcedToMin) {
      pontosParcial = Math.round(pontosParcial);
    } else {
      pontosParcial = Math.trunc(pontosParcial);
    }

    setDinheiroValue(roundCurrency(dinheiroParcial));
    setPontosValue(pontosParcial);
  }

  function exibirDinheiroPontosPagar(range) {
    if (!dataCheckout?.cart || dataCheckout?.cart?.items.length === 0) return;

    const items = Array.isArray(dataCheckout.cart.items)
      ? dataCheckout.cart.items
      : [];

    const pontosBase = items.reduce(
      (acc, item) =>
        acc + (item?.price?.points?.offer ?? 0) * (item?.quantity ?? 0),
      0,
    );
    const reaisBase = items.reduce(
      (acc, item) =>
        acc +
        (parseFloat(item?.price?.BRL?.offer ?? 0) || 0) * (item?.quantity ?? 0),
      0,
    );

    const shippingMoney = parseFloat(dataCheckout?.summary?.shipping) || 0;
    const shippingPts = getShippingPointsValue();
    const descontoMoney = parseFloat(dataCheckout?.summary?.discount) || 0;

    const totalMoney = reaisBase + shippingMoney - descontoMoney;
    const totalPoints = Math.round(pontosBase + shippingPts);

    let currentRange = Math.min(Math.max(Number(range) || 0, 0), 100);

    const balance = Math.trunc(user?.balance?.data ?? 0);
    const maxSliderValueByBalance = calcularMaxSliderValue();
    const maxSliderValueByMinPoints = calcularMaxSliderValueForMinPoints();

    if (payment_method === "pontos") {
      if (currentRange < maxSliderValueByBalance) {
        currentRange = maxSliderValueByBalance;
        setSliderValue(currentRange);
      }

      if (currentRange > maxSliderValueByMinPoints && minValue > 0) {
        currentRange = maxSliderValueByMinPoints;
        setSliderValue(currentRange);
      }
    }

    const fracDinheiro = currentRange / 100;
    let dinheiroParcial = totalMoney * fracDinheiro;
    let pontosParcial = totalPoints * (1 - fracDinheiro);

    if (pontosParcial > balance && totalPoints > 0) {
      const pontosExcedentes = pontosParcial - balance;

      const taxaConversao = totalMoney / totalPoints;
      const reaisAdicionais = pontosExcedentes * taxaConversao;
      dinheiroParcial = dinheiroParcial + reaisAdicionais;
      pontosParcial = balance;
    }

    const wasEnforcedToMin =
      minValue > 0 && pontosParcial < minValue && totalPoints >= minValue;
    if (wasEnforcedToMin) {
      pontosParcial = Math.min(minValue, totalPoints);
      const taxaConversao = totalMoney / totalPoints;
      dinheiroParcial = (totalPoints - pontosParcial) * taxaConversao;
    }

    if (!wasEnforcedToMin) {
      pontosParcial = Math.round(pontosParcial);
    } else {
      pontosParcial = Math.trunc(pontosParcial);
    }

    setDinheiroValue(roundCurrency(dinheiroParcial || 0));
    setPontosValue(pontosParcial);
  }

  function lockSlider() {
    setSliderValue(100);
    setAplicouCupon(true);
  }

  const effectiveMoneyToPay = resolveEffectiveMoneyToPay({
    cashOnly: isCashOnly,
    checkoutType: isHotelCheckout
      ? "hotel"
      : isAereoCheckout
        ? "airfare"
        : "order",
    hotelTotal: isHotelCheckout ? getHotelTotalMoney() : 0,
    airfareTotal: isAereoCheckout ? getAereoTotalMoney() : 0,
    orderTotal: dataCheckout.summary?.total,
    couponApplied: isCouponApplied,
    couponMoney: couponMoneyToPay,
    moneyValue: dinheiroValue,
  });

  const normalizePercentage = (value) => {
    if (value === null || value === undefined) return 0;

    let cleaned = String(value).replace("%", "").replace(",", "").trim();

    let num = Number(cleaned);

    if (isNaN(num)) return 0;

    return num / 100;
  };

  useEffect(() => {
    if (!isHotelCheckout && !isAereoCheckout && dataCheckout.summary?.coupon) {
      lockSlider();
    }
    if (displayMode !== "money") {
      exibirDinheiroPontosPagar(sliderValue);
    } else {
      const totalMoney = isHotelCheckout
        ? getHotelTotalMoney()
        : isAereoCheckout
          ? getAereoTotalMoney()
          : parseFloat(dataCheckout.summary?.total || 0);
      setDinheiroValue(roundCurrency(totalMoney || 0));
      setPontosValue(0);
    }

    if (isCouponApplied && displayMode !== "money") {
      setDinheiroValue(couponMoneyToPay);
    }
  }, [
    dataCheckout,
    isHotelCheckout,
    isAereoCheckout,
    displayMode,
    envisionData,
  ]);

  useEffect(() => {
    const moneyPaymentAvailable =
      paymentFlags.card !== false || paymentFlags.pix !== false;

    if (
      !moneyPaymentAvailable ||
      payment_method === "pontos" ||
      (payment_method === "both" && effectiveMoneyToPay <= 0)
    ) {
      setIsMoneyDisabled(true);
    } else {
      setIsMoneyDisabled(false);
    }

    if (effectiveMoneyToPay > 0) {
      setDisableMoneyPayment("");
    } else {
      setDisableMoneyPayment("disable");
    }
  }, [payment_method, effectiveMoneyToPay, paymentFlags]);

  useEffect(() => {
    if (mainCard && dinheiroValue > 0) {
      selecionarParcela(mainCard);
    }
  }, [dinheiroValue, mainCard]);

  async function setDefaultMainCard(cardsUser) {
    const mainCard = cardsUser.filter((card) => card.main === true);
    if (mainCard && mainCard.length) {
      setMainCard(mainCard[0]);
      return;
    }

    if (cardsUser && cardsUser.length) {
      setMainCard(cardsUser[0]);
    }
  }

  useEffect(() => {
    const checkoutParam = searchParams.get("checkout");
    if (checkoutParam === "hotel") {
      const hotelInfo = getEnvisionDataFromLocalStorage();
      if (hotelInfo) {
        setIsHotelCheckout(true);
        setEnvisionData(hotelInfo);
      } else {
        notify("Dados da reserva de hotel não encontrados.", "error");
        navigate("/loja/");
      }
    } else if (checkoutParam === "aereo") {
      const aereoInfo = getEnvisionDataFromLocalStorage();
      if (aereoInfo) {
        setIsAereoCheckout(true);
        setEnvisionData(aereoInfo);
      } else {
        notify("Dados da reserva aérea não encontrados.", "error");
        navigate("/loja/");
      }
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      const checkoutParam = searchParams.get("checkout");
      const isEnvisionMode =
        checkoutParam === "hotel" ||
        checkoutParam === "aereo" ||
        isHotelCheckout ||
        isAereoCheckout;

      if (isEnvisionMode) {
        let currentEnvisionData = envisionData;
        if (!currentEnvisionData) {
          currentEnvisionData = getEnvisionDataFromLocalStorage();
          if (currentEnvisionData) {
            if (checkoutParam === "hotel") setIsHotelCheckout(true);
            if (checkoutParam === "aereo") setIsAereoCheckout(true);
            setEnvisionData(currentEnvisionData);
          } else {
            notify("Dados da reserva não encontrados.", "error");
            navigate("/loja/");
            return;
          }
        }

        let cardsUser = [];
        try {
          cardsUser = (await getCard()) || [];
        } catch (err) {
          console.warn("Could not fetch cards for envision checkout:", err);
        }
        setCards(cardsUser);
        if (cardsUser.length > 0) {
          await setDefaultMainCard(cardsUser);
        }

        let totalMoney = 0;
        if (checkoutParam === "hotel" || isHotelCheckout) {
          const days = currentEnvisionData.datesSearchHotel?.days || 1;
          const dailyAmount =
            (currentEnvisionData.room?.markedupDailyFare?.value || 0) * days;
          const tax = 
            (currentEnvisionData.room?.dailyTax?.BRL || 0) * days;
          totalMoney = dailyAmount + tax;
        } else if (checkoutParam === "aereo" || isAereoCheckout) {
          totalMoney =
            Number(currentEnvisionData.pricing?.TotalFare?.GrandTotal) || 0;
        }

        const envisionCheckoutData = {
          cart: {
            items: [],
            shipping_by_brand: {},
          },
          summary: {
            total: totalMoney,
            shipping: 0,
            shippingPoints: 0,
            discount: 0,
            coupon: null,
          },
        };
        setDataCheckout(envisionCheckoutData);
        setLoading(false);
        return;
      }

      const checkoutResponse = await getCheckout();
      const checkoutData = checkoutResponse?.data || checkoutResponse;
      const cardsUser = await getCard();

      setCards(cardsUser);
      await setDefaultMainCard(cardsUser);

      const { allItems, shippingByBrand } = processCartData(
        checkoutData?.cart || {},
      );
      const formattedCheckoutData = {
        ...checkoutData,
        cart: {
          ...(checkoutData?.cart || {}),
          items: allItems,
          shipping_by_brand: shippingByBrand,
        },
      };

      const grouped = await groupItemsSeller(allItems);
      setItemsCart(grouped);
      setDataCheckout(formattedCheckoutData);

      if (!cartEventsSent.current) {
        trackViewCartMarketplaceItems(allItems);
        trackAddShippingInfoMarketplaceItems(
          allItems,
          formattedCheckoutData.cart?.shipping_by_brand,
        );
        cartEventsSent.current = true;
      }

      const couponInfo = formattedCheckoutData?.summary?.coupon;
      if (couponInfo) {
        const couponCode = couponInfo.code || couponInfo.name;
        setCoupon(couponCode);
        setIsValidCoupon(true);
        setIsCouponApplied(true);
        setRules(couponInfo.rules || "");
        setErrorTitle("");
        setErrorDescription("");
        setErrorCoupon("");
      } else {
        setIsCouponApplied(false);
        setIsValidCoupon(null);
      }

      setLoading(false);
    };

    const checkoutParam = searchParams.get("checkout");
    if (checkoutParam === "hotel" || checkoutParam === "aereo" || user) {
      fetchData();
    }
  }, [user, refreshCards, isHotelCheckout, isAereoCheckout, searchParams]);

  useEffect(() => {
    if (!refreshCards || !user?.cpf) return;
    (async () => {
      const cardsUser = (await getCard()) || [];
      setCards(cardsUser);
      const current = mainCardRef.current;
      if (current && !cardsUser.some((c) => c.uuid === current.uuid)) {
        await setDefaultMainCard(cardsUser);
      }
    })();
  }, [refreshCards]);

  useEffect(() => {
    if (isCouponApplied) {
      return;
    }

    if (displayMode === "money" && dataCheckout?.summary) {
      const total = parseFloat(dataCheckout.summary?.total || 0);
      setDinheiroValue(roundCurrency(total));
      setPontosValue(0);
      return;
    }

    if (
      displayMode === "both" ||
      (displayMode === "points" && dataCheckout.cart)
    ) {
      if (
        !dataCheckout.cart ||
        !dataCheckout.cart.items ||
        dataCheckout.cart.items.length === 0
      ) {
        return;
      }
      let balance = Math.trunc(user?.balance?.data);

      let pontosBase = dataCheckout.cart.items.reduce(
        (acc, item) => acc + (item.price.points?.offer || 0) * item.quantity,
        0,
      );
      let reaisBase = dataCheckout.cart.items.reduce(
        (acc, item) =>
          acc + parseFloat(item.price.BRL?.offer || 0) * item.quantity,
        0,
      );

      let shipping = parseFloat(dataCheckout.summary?.shipping || 0);
      let shippingPts = getShippingPointsValue();
      let desconto = parseFloat(dataCheckout.summary?.discount || 0);
      let pontosTotais = Math.round(pontosBase + shippingPts);
      let reaisTotais = reaisBase + shipping - desconto;

      let initialRange = 0;
      if (balance >= pontosTotais) {
        initialRange = 0;
      } else {
        initialRange = ((pontosTotais - balance) / pontosTotais) * 100;
      }
      initialRange = Math.min(initialRange, 100);

      const maxSliderValueByMinPoints = calcularMaxSliderValueForMinPoints();
      if (initialRange > maxSliderValueByMinPoints && minValue > 0) {
        initialRange = maxSliderValueByMinPoints;
      }

      setSliderValue(initialRange);

      let range = initialRange / 100;
      let dinheiroParcial = reaisTotais * range;
      let pontosParcial = pontosTotais * (1 - range);

      if (pontosParcial > balance && pontosTotais > 0) {
        const pontosExcedentes = pontosParcial - balance;
        const taxaConversao = reaisTotais / pontosTotais;
        const reaisAdicionais = pontosExcedentes * taxaConversao;
        dinheiroParcial = dinheiroParcial + reaisAdicionais;
        pontosParcial = balance;
      }

      const wasEnforcedToMin =
        minValue > 0 && pontosParcial < minValue && pontosTotais >= minValue;
      if (wasEnforcedToMin) {
        pontosParcial = Math.min(minValue, pontosTotais);
        const taxaConversao = reaisTotais / pontosTotais;
        dinheiroParcial = (pontosTotais - pontosParcial) * taxaConversao;
        initialRange = ((pontosTotais - pontosParcial) / pontosTotais) * 100;
        setSliderValue(Math.min(Math.max(initialRange, 0), 100));
      }

      if (!wasEnforcedToMin) {
        pontosParcial = Math.round(pontosParcial);
      } else {
        pontosParcial = Math.trunc(pontosParcial);
      }

      setDinheiroValue(roundCurrency(dinheiroParcial));
      setPontosValue(pontosParcial);
    }
  }, [
    dataCheckout.cart,
    dataCheckout.summary?.total,
    payment_method,
    user?.balance?.data,
    displayMode,
  ]);

  useEffect(() => {
    if (!isCouponApplied || !dataCheckout.summary?.coupon || isAereoCheckout || isHotelCheckout) {
      return;
    }

    if (displayMode === "money") {
      const totalAfterCoupon = parseFloat(dataCheckout.summary?.total || 0);
      setPontosValue(0);
      setDinheiroValue(roundCurrency(totalAfterCoupon));
      setCouponMoneyToPay(totalAfterCoupon);
      return;
    }

    const balance = Math.trunc(user?.balance?.data || 0);
    const factor = fatorFrete > 0 ? 1 / fatorFrete : 1;
    const totalAfterCoupon = parseFloat(dataCheckout.summary?.total || 0);
    const discount = parseFloat(dataCheckout.summary?.discount || 0);
    const discountInPts = Math.round(discount * factor);
    const totalPointsWithCoupon = Math.max(0, totalPoints - discountInPts);

    let pontosParcial = totalPointsWithCoupon;
    let dinheiroParcial = 0;

    if (pontosParcial > balance && totalPointsWithCoupon > 0) {
      pontosParcial = balance;
      const pointsInMoney = pontosParcial / factor;
      dinheiroParcial = totalAfterCoupon - pointsInMoney;
    }

    if (
      minValue > 0 &&
      pontosParcial < minValue &&
      totalPointsWithCoupon >= minValue
    ) {
      pontosParcial = Math.min(minValue, totalPointsWithCoupon);
      const pointsInMoney = pontosParcial / factor;
      dinheiroParcial = totalAfterCoupon - pointsInMoney;
    }

    setPontosValue(pontosParcial);
    setDinheiroValue(roundCurrency(dinheiroParcial));
    setCouponMoneyToPay(dinheiroParcial);
  }, [
    isCouponApplied,
    dataCheckout.summary,
    user?.balance?.data,
    fatorFrete,
    minValue,
    totalPoints,
    displayMode,
  ]);

  useEffect(() => {
    if (isHotelCheckout && envisionData) {
      const totalMoney = getHotelTotalMoney();
      const totalPoints = getHotelTotalPoints();
      if (isCashOnly) {
        setSliderValue(100);
        setDinheiroValue(roundCurrency(totalMoney));
        setPontosValue(0);
        return;
      }
      const balance = Math.trunc(user?.balance?.data || 0);

      let initialRange = 0;
      if (balance >= totalPoints) {
        initialRange = 0;
      } else {
        initialRange = Math.min(
          ((totalPoints - balance) / totalPoints) * 100,
          100,
        );
      }

      setSliderValue(initialRange);

      const range = initialRange / 100;
      let dinheiroParcial = totalMoney * range;
      let pontosParcial = totalPoints * (1 - range);

      if (pontosParcial > balance && totalPoints > 0) {
        const pontosExcedentes = pontosParcial - balance;
        const taxaConversao = totalMoney / totalPoints;
        const reaisAdicionais = pontosExcedentes * taxaConversao;
        dinheiroParcial = dinheiroParcial + reaisAdicionais;
        pontosParcial = balance;
      }

      setDinheiroValue(roundCurrency(dinheiroParcial));
      setPontosValue(Math.round(pontosParcial));
    } else if (isAereoCheckout && envisionData) {
      const totalMoney = getAereoTotalMoney();
      const totalPoints = getAereoTotalPoints();
      if (isCashOnly) {
        setSliderValue(100);
        setDinheiroValue(roundCurrency(totalMoney));
        setPontosValue(0);
        return;
      }
      const balance = Math.trunc(user?.balance?.data || 0);

      let initialRange = 0;
      if (balance >= totalPoints) {
        initialRange = 0;
      } else {
        initialRange = Math.min(
          ((totalPoints - balance) / totalPoints) * 100,
          100,
        );
      }

      setSliderValue(initialRange);

      const range = initialRange / 100;
      let dinheiroParcial = totalMoney * range;
      let pontosParcial = totalPoints * (1 - range);

      if (pontosParcial > balance && totalPoints > 0) {
        const pontosExcedentes = pontosParcial - balance;
        const taxaConversao = totalMoney / totalPoints;
        const reaisAdicionais = pontosExcedentes * taxaConversao;
        dinheiroParcial = dinheiroParcial + reaisAdicionais;
        pontosParcial = balance;
      }

      setDinheiroValue(roundCurrency(dinheiroParcial));
      setPontosValue(Math.round(pontosParcial));
    }
  }, [
    isHotelCheckout,
    isAereoCheckout,
    envisionData,
    user?.balance?.data,
    isCouponApplied,
    dataCheckout.summary?.coupon,
    dataCheckout.summary?.discount,
    isCashOnly,
  ]);

  useEffect(() => {
    if (isHotelCheckout) {
      const minPurchaseHotelKey = `${channel}_min_purchase_hotel`;
      const minValueHotelKey = `${channel}_min_value_hotel`;

      const total = getHotelTotalPoints();
      const minimumPercentage = normalizePercentage(
        configData[minPurchaseHotelKey],
      );
      const minPointsPercentage = parseInt((total * minimumPercentage) / 100);
      const minPaymentPoints = normalizePercentage(
        configData[minValueHotelKey],
      );

      setMinValue(Math.max(minPointsPercentage, minPaymentPoints));
      return;
    }

    if (isAereoCheckout) {
      const minPurchaseAereoKey = `${channel}_min_purchase_aereo`;
      const minValueAereoKey = `${channel}_min_value_aereo`;

      const total = getAereoTotalPoints();
      const minimumPercentage = normalizePercentage(
        configData[minPurchaseAereoKey],
      );
      const minPointsPercentage = parseInt((total * minimumPercentage) / 100);
      const minPaymentPoints = normalizePercentage(
        configData[minValueAereoKey],
      );

      setMinValue(Math.max(minPointsPercentage, minPaymentPoints));
      return;
    }

    setMinValue(Number(configData?.[`${channel}_min_value`]) || 0);
  }, [isHotelCheckout, isAereoCheckout, envisionData, configData]);

  useEffect(() => {
    if (dataCheckout.summary?.coupon && payment_method === "pontos") {
      removeCoupon();
    }
  }, [dataCheckout, payment_method]);

  const isCouponAppliedRef = useRef(isCouponApplied);
  useEffect(() => {
    isCouponAppliedRef.current = isCouponApplied;
  }, [isCouponApplied]);

  useEffect(() => {
    return () => {
      if (isCouponAppliedRef.current) {
        couponApi
          .post(`/api/coupon/remove/${channel}`, {
            customerUuid: user?.uuid,
            cep: addressShipping?.cep,
          })
          .catch(() => {});
      }
    };
  }, [channel, user?.uuid, addressShipping?.cep]);

  useEffect(() => {
    return () => {
      setInstallments([]);
      setInstallmentsSelected("");

      const currentMainCard = mainCardRef.current;

      if (currentMainCard && !currentMainCard.uuid) {
        setMainCard(null);
      }
    };
  }, [location.pathname, setMainCard]);

  async function getInstallments(customerUuid, totalAmount, type = "produto") {
    return await pedidosApi.get(`v1/installment/options/${channel}`, {
      params: {
        customerUuid: customerUuid,
        amount: totalAmount,
        installmentType: type,
      },
    });
  }

  async function selecionarParcela(card) {
    const cashOnlyTravelTotal = isHotelCheckout
      ? getHotelTotalMoney()
      : isAereoCheckout
        ? getAereoTotalMoney()
        : dinheiroValue;
    let valorTotal = parseFloat(
      isCashOnly
        ? cashOnlyTravelTotal
        : isCouponApplied
          ? couponMoneyToPay
          : dinheiroValue,
    );
    if (isNaN(valorTotal)) {
      return;
    }

    if (card && card.last_four_digits) {
      if (valorTotal <= 0) {
        return;
      }

      setDisableMoneyPayment("disable");
      const installmentType = isHotelCheckout
        ? "hotel"
        : isAereoCheckout
          ? "air_ticket"
          : "produto";
      const result = await getInstallments(
        user.uuid,
        valorTotal,
        installmentType,
      );
      if (valorTotal > 0) {
        setInstallments(Object.values(result.data.data));
      }
      setDisableMoneyPayment("");
    }
  }

  const handlePaymentSelect = useCallback(
    (method) => {
      setSelectedPaymentMethod(method);
      if (method.type === "pix") {
        setMainCard(null);
        setInstallmentsSelected(undefined);
        setInstallments([]);
      }
    },
    [setMainCard],
  );

  function handleCardSelectFromPayment(card) {
    if (card && card.last_four_digits) {
      setMainCard(card);
      selecionarParcela(card);
    }
  }

  function handleInstallmentFromPayment(value) {
    setInstallmentsSelected(value);
  }

  const ERROR_MESSAGES = Object.freeze({
    COUPON_NOT_APPLICABLE: {
      title: "Cupom não aplicado.",
      message: "O cupom não é válido para nenhum item do seu carrinho.",
    },
    COUPON_EXPIRED: {
      title: "Cupom vencido.",
      message: "O período para utilização deste cupom foi encerrado.",
    },
    COUPON_OUT_OF_STOCK: {
      title: "Cupom esgotado.",
      message: "Todos os cupons disponíveis já foram utilizados.",
    },
    COUPON_INACTIVE: {
      title: "Cupom esgotado.",
      message: "Todos os cupons disponíveis já foram utilizados.",
    },
    INVALID_COUPON: {
      title: "Cupom inválido.",
      message: "O cupom não é válido ou já foi utilizado.",
    },
    INVALID_CPF_FOR_COUPON: {
      title: "Cupom não disponível.",
      message: "Este cupom não está disponível para o seu CPF.",
    },
    COUPON_INVALID_PRODUCT: {
      title: "Cupom não aplicado.",
      message: "Este cupom não é válido para o produto selecionado.",
    },
    COUPON_MINIMUM_ORDER: {
      title: "Valor mínimo não atingido.",
      message: "O valor do pedido não atinge o mínimo exigido por este cupom.",
    },
    GENERIC_ERROR: {
      title: "Cupom não aplicado.",
      message: "Ocorreu um erro ao aplicar o cupom.",
    },
  });

  function getErrorMessage(code) {
    return ERROR_MESSAGES[code];
  }

  async function applyCoupon() {
    if (!couponsEnabled) return;
    trackResumoCompraEvent({ title: "aplicar-cupom" });
    setLoadingCoupon(true);

    try {
      let responseData;
      let status;

      const type = isAereoCheckout ? 'ticket' : isHotelCheckout ? 'hotel' : 'marketplace';

      const payload = {
        customerUuid: user.uuid,
        coupon: coupon,
        productType: type,
      };

      if (!isAereoCheckout && !isHotelCheckout) {
        payload.cep = addressShipping?.cep || "";
        payload.fator = fatorFrete;
      }

      const response = await couponApi.post(`/api/coupon/apply/${channel}`, payload);
      responseData = response.data?.data;
      status = response.status;

      if (status === 200 && responseData) {
        if (isAereoCheckout || isHotelCheckout) {
          const couponInfo = responseData || {};

          let fareBase;
          if (isAereoCheckout) {
            const pricing = envisionData?.pricing || {};
            const totalFare = pricing.TotalFare || {};
            fareBase = Number(totalFare.TotalFare) || 0;
          } else {
            const room = getHotelRoom();
            if (!room) return;
            const nights = getHotelNights();
            fareBase = Number(room.markedupDailyFare.value * nights);
          }

          const minimumOrderValue = Number(couponInfo.value_minimum_order) || 0;
          const maxDiscountValue = couponInfo.discount_maximum_in_real ? Number(couponInfo.discount_maximum_in_real) : null;
          const allowZeroPurchase = couponInfo.allow_zero_purchase || false;

          if (fareBase < minimumOrderValue) {
            const errorData = getErrorMessage("invalid_minimum");
            setErrorCoupon("Cupom não aplicado");
            setIsValidCoupon(false);
            setIsCouponApplied(false);
            setRules(couponInfo.rules);
            setErrorCode("invalid_minimum");
            setErrorTitle(errorData?.title || "Valor mínimo não atingido");
            setErrorDescription(
              errorData?.message || `O pedido mínimo para aplicar este cupom é R$ ${minimumOrderValue.toFixed(2)}.`,
            );
            notify(
              `O pedido mínimo para aplicar este cupom é R$ ${minimumOrderValue.toFixed(2)}.`,
              "error",
            );
            return;
          }

          let discountBRL = 0;
          if (couponInfo.discount_type === 1) {
            discountBRL = Number(couponInfo.discount_value) || 0;
          } else if (couponInfo.discount_type === 2) {
            const pct = Number(couponInfo.discount_value) / 100 || 0;
            discountBRL = fareBase * pct;

            if (maxDiscountValue !== null && discountBRL > maxDiscountValue) {
              discountBRL = maxDiscountValue;
            }
          }

          if (discountBRL > fareBase) {
            if (!allowZeroPurchase) {
              const errorData = getErrorMessage("invalid_coupon");
              setErrorCoupon("Cupom não aplicado");
              setIsValidCoupon(false);
              setIsCouponApplied(false);
              setRules(couponInfo.rules);
              setErrorCode("invalid_coupon");
              setErrorTitle(errorData?.title || "Cupom não aplicado");
              setErrorDescription(errorData?.message || "O valor do cupom excede o valor da tarifa.");
              notify("Cupom não aplicado, o valor do cupom excede o valor da tarifa.", "error");
              return;
            }
            discountBRL = fareBase;
          }

          setDataCheckout((prev) => ({
            ...(prev || {}),
            summary: {
              ...((prev && prev.summary) || {}),
              coupon: couponInfo,
            },
          }));
          setRules(couponInfo.rules || "");
          setCoupon(couponInfo.code || coupon);

          setErrorCoupon("");
          setIsValidCoupon(true);
          notify(
            couponInfo.message ||
              `O cupom ${couponInfo.code || coupon} foi aplicado.`,
            "success",
          );
          setIsCouponApplied(true);
          setAplicouCupon(true);

          const totalPoints = getAereoTotalPoints();
          const balance = Math.floor(Number(user?.balance?.data || 0));

          if (balance >= totalPoints) {
            setPontosValue(totalPoints);
            setDinheiroValue(0);
            setCouponMoneyToPay(0);
          } else {
            setPontosValue(balance);
            const remainingPoints = totalPoints - balance;
            const remainingMoney = roundCurrency(
              remainingPoints * fatorAirTicket,
            );
            setDinheiroValue(remainingMoney);
            setCouponMoneyToPay(remainingMoney);
          }
          return;
        }

        const responseDataRaw = responseData;
        const summary = responseDataRaw.summary || {};
        const couponInfo = summary.coupon || {};
        const { allItems, shippingByBrand } = processCartData(
          responseData.cart || {},
        );
        const formattedCheckoutData = {
          ...responseData,
          cart: {
            ...(responseData.cart || {}),
            items: allItems,
            shipping_by_brand: shippingByBrand,
          },
        };
        const grouped = await groupItemsSeller(allItems);
        setItemsCart(grouped);
        setDataCheckout(formattedCheckoutData);
        setRules(couponInfo.rules || "");
        setCoupon(couponInfo.code || coupon);

        const totalPayment = Number(summary.total) || 0;
        setDinheiroValue(roundCurrency(totalPayment));
        setCouponMoneyToPay(totalPayment);

        setErrorCoupon("");
        setIsValidCoupon(true);
        lockSlider();
        notify(
          couponInfo.message ||
            `O cupom ${couponInfo.code || coupon} foi aplicado.`,
          "success",
        );
        setIsCouponApplied(true);
      } else {
        const errorData = getErrorMessage(data?.code);
        setErrorCoupon("Falha ao aplicar cupom");
        setIsValidCoupon(false);
        setIsCouponApplied(false);
        setRules(data?.rules);
        setErrorCode(data?.code || "");
        setErrorTitle(errorData?.title || data?.title || "Cupom não aplicado.");
        setErrorDescription(
          errorData?.message ||
            data?.message ||
            "Ocorreu um erro ao aplicar o cupom.",
        );
      }
    } catch (e) {
      const responseData = e?.response?.data;
      const errorData = getErrorMessage(responseData?.code);

      setErrorCoupon("Falha ao aplicar cupom");
      setIsValidCoupon(false);
      setIsCouponApplied(false);

      setRules(responseData?.rules);
      setErrorCode(responseData?.code || "");
       setErrorTitle(
        errorData?.title || responseData?.title || "Cupom não aplicado.",
      );
      setErrorDescription(
        errorData?.message ||
          responseData?.message ||
          "Ocorreu um erro ao aplicar o cupom.",
      );
    } finally {
      setLoadingCoupon(false);
    }
  }

  async function removeCoupon(shouldNotify = true) {
    if (!couponsEnabled) return;
    trackResumoCompraEvent({ title: "excluir-cupom" });
    setLoadingCoupon(true);

    try {
      if (!isAereoCheckout && !isHotelCheckout) {
        await couponApi.post(`/api/coupon/remove/${channel}`, {
          customerUuid: user.uuid,
          cep: addressShipping?.cep || "",
        });
      }

      setCoupon("");
      setAplicouCupon(false);
      setIsCouponApplied(false);
      setCouponMoneyToPay(0);
      setIsValidCoupon(null);
      setErrorTitle("");
      setErrorDescription("");
      setErrorCoupon("");
      setErrorCode("");
      setRules("");
      setRulesExpanded(false);

      if (isAereoCheckout || isHotelCheckout) {
        
        let totalMoney;
        let totalPoints;

        if (isAereoCheckout) {
          totalMoney = getAereoTotalMoney();
          totalPoints = getAereoTotalPoints();
        } else {
          totalMoney = getHotelTotalMoney();
          totalPoints = getHotelTotalPoints();
        }
        
        const balance = Math.trunc(user?.balance?.data ?? 0);

        if (balance >= totalPoints) {
          setPontosValue(totalPoints);
          setDinheiroValue(0);
        } else {
          setPontosValue(balance);
          const remainingPoints = totalPoints - balance;
          setDinheiroValue(roundCurrency(remainingPoints * fatorAirTicket));
        }

        setDataCheckout({
          cart: {
            items: [],
            shipping_by_brand: {},
          },
          summary: {
            total: totalMoney,
            shipping: 0,
            shippingPoints: 0,
            discount: 0,
            coupon: null,
          },
        });
      } else {
        const formattedCheckoutData = await fetchAndProcessCartData();
        setDataCheckout(formattedCheckoutData);

        const grouped = await groupItemsSeller(
          formattedCheckoutData.cart.items,
        );
        setItemsCart(grouped);
      }

      if (shouldNotify) {
        notify(`O cupom foi removido.`, "success");
      }
    } catch (e) {
      if (shouldNotify) {
        notify("Erro ao remover cupom.", "error");
      }
    } finally {
      setLoadingCoupon(false);
    }
  }

  async function HandleFinished() {
    trackResumoCompraEvent({ title: "finalizar-compra" });

    async function refreshUserBalance() {
      if (displayMode === "money") return;
      try {
        const balance = await clientesApi.get(`customer/${user.cpf}/balance`);
        const userData = getCustomerFromMemory();
        if (!userData) return;
        userData.data.balance = { data: balance.data.data };
        setCustomerInMemory(userData);
        updateUserData();
      } catch (error) {
        console.error("Falha ao atualizar saldo após compra:", error);
      }
    }

    const userBalance = Math.trunc(user?.balance?.data || 0);
    if (displayMode !== "money" && minValue > 0 && userBalance < minValue) {
      setShowInsufficientPoints(true);
      return;
    }

    if (effectiveMoneyToPay > 0) {
      if (!selectedPaymentMethod) {
        return notify("Selecione uma forma de pagamento.", "error");
      }
      if (selectedPaymentMethod.type === "credit_card") {
        if (!mainCard)
          return notify("Informe o cartão para o pagamento.", "error");
        if (!installmentsSelected)
          return notify("Selecione a quantidade de parcelas.", "error");
      }
    }

    if (selectedPaymentMethod?.type === "pix") {
      setLoadingCheckout(true);
      try {
        const pixCheckout = {
          totalAmount: effectiveMoneyToPay || dataCheckout.summary.total,
          customerData: {
            pagarmeId: null,
            customerUuid: user.uuid,
            createdAt: user.created_at
              ? new Date(user.created_at).toISOString().split("T")[0]
              : new Date().toISOString().split("T")[0],
            firstName: user.nome,
            lastName: user.sobrenome,
            cpf: user.cpf,
            email: user.email,
            phones: {
              number: user.telefone,
            },
            address: buildCustomerAddress(),
          },
          paymentBRL: {
            type: "PIX",
            amount: effectiveMoneyToPay,
          },
        };

        if (
          displayMode === "points" ||
          (displayMode === "both" && fatorFrete > 0 && pontosValue > 0)
        ) {
          pixCheckout.paymentPoints = {
            fator: fatorFrete,
            amount: Math.round(pontosValue) || 0,
          };
        }

        const response = await pedidosApi.post(
          `v2/checkout/finalizar-pedido/${channel}`,
          pixCheckout,
        );

        const responseData = response?.data?.data || {};
        const { orderId, pixCode, pixQrCode, pixExpiresAt } = responseData;
        const orderUuid = orderId || responseData.orderUuid;

        const uuid = user.uuid;
        Object.keys(itemsCart).forEach((store) => {
          itemsCart[store].forEach((product) => {
            const sku = product.item?.sku ?? product.sku;
            const cep = addressShipping.cep;
            dispatch(removeItemCart({ sku, uuid, cep })).unwrap();
          });
        });

        await refreshUserBalance();

        trackPurchaseMarketplaceItems(dataCheckout.cart?.items || [], {
          transactionId: orderUuid,
          value: parseFloat(dataCheckout.summary?.total || 0),
          shipping: parseFloat(dataCheckout.summary?.shipping || 0),
          coupon:
            dataCheckout.summary?.coupon?.code ||
            dataCheckout.summary?.coupon?.name ||
            "",
        });

        navigate(`/loja/pixconfirmation/${orderUuid}`, {
          state: { pixCode, pixQrCode, pixExpiresAt },
        });
      } catch (error) {
        navigate("/loja/ordernotapproved");
      } finally {
        setLoadingCheckout(false);
      }
      return;
    }

    setLoadingCheckout(true);

    if (isHotelCheckout && envisionData) {
      try {
        const room = getHotelRoom();
        const hotel = getHotel();
        const nights = getHotelNights();
        const fixedTravellers = (envisionData.travellers || []).map(
          (traveller) => ({
            ...traveller,
            documents: (traveller.documents || []).map((doc) => {
              const { documenType, ...rest } = doc;
              return {
                ...rest,
                documentType: doc.documentType || documenType,
              };
            }),
          }),
        );

        const sanitizedHotel = normalizeHotelCheckoutData(
          envisionData.hotel,
          isCashOnly,
        );

        const hotelTotalPoints = getHotelTotalPoints();
        const hotelTotalMoney = getHotelTotalMoney();
        const finalPontosValue =
          displayMode === "money"
            ? 0
            : pontosValue > 0
              ? Math.round(pontosValue)
              : Math.round(hotelTotalPoints);
        const finalMoneyValue =
          effectiveMoneyToPay > 0 ? effectiveMoneyToPay : 0;

        const paymentLabel =
          finalPontosValue > 0 && finalMoneyValue > 0
            ? "Pontos + Cartao"
            : finalPontosValue > 0
              ? "Pontos"
              : "Cartao";

        if (room && hotel) {
          const hotelPaymentEvent = {
            hotel_name: hotel?.name,
            room_name: room?.name,
            points: finalPontosValue,
            cash: finalMoneyValue,
            total_value: hotelTotalMoney,
            total_points: hotelTotalPoints,
            check_in: formatHotelDate(room.checkIn),
            check_out: formatHotelDate(room.checkOut),
            payment: paymentLabel,
            nights,
            stars: hotel?.stars,
            hosts: (envisionData?.travellers || []).length,
          };

          trackHotelPayment(hotelPaymentEvent);
        }

        let paymentType = "CREDIT";
        if (finalPontosValue > 0 && finalMoneyValue > 0) {
          paymentType = "BOTH";
        } else if (finalPontosValue > 0 && finalMoneyValue <= 0) {
          paymentType = "POINTS";
        }

        const hotelCheckoutPayload = {
          orderType: "hotel",
          discount: {
            code: isCouponApplied ? coupon : null,
          },
          customerData: {
            pagarmeId: null,
            customerUuid: envisionData.customerId || user.uuid,
            createdAt: user.created_at
              ? new Date(user.created_at).toISOString().split("T")[0]
              : new Date().toISOString().split("T")[0],
            firstName: user.nome,
            lastName: user.sobrenome,
            cpf: user.cpf,
            email: user.email,
            phones: {
              number: user.telefone,
            },
            address: buildCustomerAddress(),
          },
          travellers: fixedTravellers,
          hotel: sanitizedHotel,
          paymentPoints: {
            amount: finalPontosValue,
            fator: fatorHotel,
          },
          paymentBRL: {
          type: paymentType,
            amount: Number(finalMoneyValue.toFixed(2)),
            originalAmount: Number(effectiveMoneyToPay.toFixed(2)),
            installments: installmentsSelected || 1,
            save: false,
            mainCard: false,
            cardUuid: mainCard?.uuid || null,
            gatewayCardKey: mainCard?.hash || null,
          }
        };

        const response = await handleHotelCheckout(hotelCheckoutPayload);
        const orderUuid = response.data?.data?.orderUuid;

        if (orderUuid) {
          const authorizeOrder = await pedidosApi.post(
            `v1/pedidos/${channel}/authorization/` + orderUuid,
            {
              authorized: true,
            },
          );

          if (
            authorizeOrder?.data?.data?.status?.toLowerCase() ===
            ORDER_STATUS.DENIED
          ) {
            trackHotelCallback({
              status: "error",
              action: "checkout",
              error: "Payment Denied",
            });
            navigate(`/loja/ordernotapproved`);
            return;
          }

          await refreshUserBalance();

          if (room && hotel) {
            const bookingPayload = {
              order_id: orderUuid,
              hotel_name: hotel?.name,
              room_name: room?.name,
              points: finalPontosValue,
              cash: finalMoneyValue,
              total_value: hotelTotalMoney,
              total_points: hotelTotalPoints,
              check_in: formatHotelDate(room.checkIn),
              check_out: formatHotelDate(room.checkOut),
              payment: paymentLabel,
              nights,
              stars: hotel?.stars,
              hosts: (envisionData?.travellers || []).length,
            };

            localStorage.setItem(
              "hotel_booking_event",
              JSON.stringify(bookingPayload),
            );
          }

          localStorage.removeItem("envision");
          navigate(`/loja/checkout-message-travel/${orderUuid}`);
        } else {
          notify("Pedido criado, mas sem ID retornado.", "warning");
          navigate("/loja/checkout-message-travel");
        }
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          "Erro ao finalizar reserva de hotel.";
        notify(errorMessage, "error");
        navigate("/loja/checkout-message-travel");
      } finally {
        setLoadingCheckout(false);
      }
      return;
    }

    if (isAereoCheckout && envisionData) {
      try {
        const aereoTotalPoints = getAereoTotalPoints();
        const aereoTotalMoney = getAereoTotalMoney();
        const finalPontosValue =
          displayMode === "money"
            ? 0
            : pontosValue > 0
              ? Math.round(pontosValue)
              : Math.round(aereoTotalPoints);

        const selectedInstallmentData = (installments || []).find(
          (i) => i.installmentNumber == installmentsSelected,
        );

        const amountWithInterest = selectedInstallmentData
          ? parseFloat(
              (
                selectedInstallmentData.installmentPrice *
                selectedInstallmentData.installmentNumber
              ).toFixed(2),
            )
          : effectiveMoneyToPay;

        const finalMoneyValue =
          amountWithInterest > 0 ? amountWithInterest : 0;

        let paymentType = "CREDIT";
        if (finalPontosValue > 0 && finalMoneyValue > 0) {
          paymentType = "BOTH";
        } else if (finalPontosValue > 0 && finalMoneyValue <= 0) {
          paymentType = "POINTS";
        }

        const segments = envisionData.choosenFlight?.segments || {};
        const depFlights = segments.departureFlights || {};
        const retFlights = segments.returnFlights || {};
        const airportsMap = segments.airports || {};
        const passengers = envisionData.choosenFlight?.passengers || [];

        const makeAirportLabel = (code) => {
          const a = airportsMap[code] || {};
          return a.CityName ? `${a.CityName} (${a.Code || code})` : code || "";
        };

        const departureLabel = makeAirportLabel(depFlights.DepartureStation);
        const arrivalLabel = makeAirportLabel(depFlights.ArrivalStation);

        const formatFlightDate = (isoStr) => {
          if (!isoStr) return "";
          const d = new Date(isoStr);
          if (Number.isNaN(d.getTime())) return "";
          return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
        };

        const depDate = formatFlightDate(depFlights.DepartureDateTime);
        const retDate = formatFlightDate(retFlights.DepartureDateTime);

        const firstFlight = depFlights.Flights?.[0] || {};
        const cabinClass = firstFlight.FareOption?.Cabin || "Econômica";
        const tripType = retFlights.Flights?.length > 0 ? "Retorno" : "Somente ida";

        const adultsCount = passengers.filter(p => p.type === "adult" || p.Type === "ADT").length || passengers.length || 0;
        const childrenCount = passengers.filter(p => p.type === "child" || p.Type === "CHD").length || 0;
        const babyCount = passengers.filter(p => p.type === "baby" || p.type === "infant" || p.Type === "INF").length || 0;

        const paymentLabel =
          finalPontosValue > 0 && finalMoneyValue > 0
            ? "Pontos + Cartão"
            : finalPontosValue > 0
              ? "Pontos"
              : "Cartão";

        trackFlightPayment({
          departure: departureLabel,
          arrival: arrivalLabel,
          depating: depDate,
          returning: retDate,
          passengers: passengers.length || adultsCount + childrenCount + babyCount,
          class: cabinClass,
          type: tripType,
          adults: adultsCount,
          payment: paymentLabel,
          children: childrenCount,
          baby: babyCount,
          total_cash: aereoTotalMoney,
          cash: finalMoneyValue,
          total_points: aereoTotalPoints,
          points: finalPontosValue,
        });

        const aereoCheckoutPayload = {
          orderType: "air_ticket",
          chooseId: envisionData.choose_id || "",
          discount: {
            code: isCouponApplied ? coupon : null,
          },
          customerData: {
            pagarmeId: null,
            customerUuid: envisionData.customerId || user.uuid,
            createdAt: user.created_at
              ? new Date(user.created_at).toISOString().split("T")[0]
              : new Date().toISOString().split("T")[0],
            firstName: user.nome,
            lastName: user.sobrenome,
            cpf: user.cpf,
            email: user.email,
            phones: {
              number: user.telefone,
            },
            address: buildCustomerAddress(),
          },
          paymentPoints: {
            amount: finalPontosValue,
            fator: fatorAirTicket,
          },
          paymentBRL: {
            type: paymentType,
            amount: Number(finalMoneyValue.toFixed(2)),
            originalAmount: Number(effectiveMoneyToPay.toFixed(2)),
            installments: installmentsSelected || 1,
            save: false,
            mainCard: false,
            cardUuid: mainCard?.uuid || null,
            gatewayCardKey: mainCard?.hash || null,
          },
        };

        const response = await handleHotelCheckout(aereoCheckoutPayload);
        const orderUuid = response.data?.data?.orderUuid;

        if (orderUuid) {
          const authorizeOrder = await pedidosApi.post(
            `v1/pedidos/${channel}/authorization/` + orderUuid,
            {
              authorized: true,
            },
          );

          if (
            authorizeOrder?.data?.data?.status?.toLowerCase() ===
            ORDER_STATUS.DENIED
          ) {
            navigate(`/loja/ordernotapproved`);
            return;
          }

          await refreshUserBalance();

          trackFlightTransaction({
            departure: departureLabel,
            arrival: arrivalLabel,
            depating: depDate,
            returning: retDate,
            passengers: passengers.length || adultsCount + childrenCount + babyCount,
            class: cabinClass,
            type: tripType,
            adults: adultsCount,
            children: childrenCount,
            baby: babyCount,
            order_id: orderUuid,
            payment: paymentLabel,
            total_cash: aereoTotalMoney,
            cash: finalMoneyValue,
            total_points: aereoTotalPoints,
            points: finalPontosValue,
          });

          localStorage.removeItem("envision");
          navigate(`/loja/checkout-message-travel/${orderUuid}`);
        } else {
          notify("Pedido criado, mas sem ID retornado.", "warning");
          navigate("/loja/checkout-message-travel");
        }
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message || "Erro ao finalizar reserva aérea.";
        notify(errorMessage, "error");
        navigate("/loja/checkout-message-travel");
      } finally {
        setLoadingCheckout(false);
      }
      return;
    }

    let type = "CREDIT";

    if (effectiveMoneyToPay > 0 && pontosValue > 0) {
      type = "BOTH";
    } else if (effectiveMoneyToPay <= 0 && pontosValue > 0) {
      type = "POINTS";
    }

    const checkout = {
      totalAmount: effectiveMoneyToPay || dataCheckout.summary.total,
      customerData: {
        pagarmeId: null,
        customerUuid: user.uuid,
        createdAt: user.created_at
          ? new Date(user.created_at).toISOString().split("T")[0]
          : new Date().toISOString().split("T")[0],
        firstName: user.nome,
        lastName: user.sobrenome,
        cpf: user.cpf,
        email: user.email,
        pagarmeId: null,
        phones: {
          number: user.telefone,
        },
        address: buildCustomerAddress(),
      },
      paymentBRL: {
        type: type,
        amount: effectiveMoneyToPay,
        installments: installmentsSelected || 1,
        save: false,
        mainCard: false,
        cardUuid: null,
        gatewayCardKey: null,
      },
    };

    if (mainCard && mainCard.uuid) {
      checkout.paymentBRL.cardUuid = mainCard.uuid;
    } else if (mainCard && mainCard.hash) {
      checkout.paymentBRL.gatewayCardKey = mainCard.hash;
    }

    if (
      displayMode === "points" ||
      (displayMode === "both" && fatorFrete > 0 && pontosValue > 0)
    ) {
      const amountPoints = Math.round(pontosValue);

      checkout.paymentPoints = {
        fator: fatorFrete,
        amount: amountPoints || 0,
      };
    }

    const uuid = user.uuid;

    pedidosApi
      .post(`v2/checkout/finalizar-pedido/${channel}`, checkout)
      .then(async (response) => {
        const orderUuid = response?.data?.data?.orderUuid;
        if (orderUuid) {
          const authorizeOrder = await pedidosApi.post(
            `v1/pedidos/${channel}/authorization/` + orderUuid,
            {
              authorized: true,
            },
          );

          if (
            authorizeOrder?.data?.data?.status?.toLowerCase() ===
            ORDER_STATUS.DENIED
          ) {
            navigate(`/loja/ordernotapproved`);
            return;
          }

          await refreshUserBalance();

          trackPurchaseMarketplaceItems(dataCheckout.cart?.items || [], {
            transactionId: orderUuid,
            value: parseFloat(dataCheckout.summary?.total || 0),
            shipping: parseFloat(dataCheckout.summary?.shipping || 0),
            coupon:
              dataCheckout.summary?.coupon?.code ||
              dataCheckout.summary?.coupon?.name ||
              "",
          });

          Object.keys(itemsCart).map(function (store) {
            itemsCart[store].map(function (product) {
              const sku = product.item?.sku ?? product.sku;
              const cep = addressShipping.cep;
              dispatch(removeItemCart({ sku, uuid, cep })).unwrap();
            });
          });
          navigate(`/loja/orderresumestatus/${orderUuid}`);
        }
      })
      .catch((error) => {
        const response = error?.response?.data || {
          message: "Não foi possível completar sua operação.",
        };
        navigate(`/loja/ordernotapproved`);
      })
      .finally((result) => {
        setUpdateUser(new Date());
      });
  }

  if (dataCheckout.length === 0) return <LoaderSmall />;

  if (loadingCheckout) return <LoaderSmall />;

  if (loading) return <LoaderSmall />;

  const getValueByDisplayMode = (product, displayMode, dataCheckout) => {
    const { price } = product;

    switch (displayMode) {
      case "money":
        return parseFloat(dataCheckout.summary?.total || 0);

      case "points":
        return parseInt(price?.points?.offer || 0, 10);

      case "both":
        return {
          money: parseFloat(dataCheckout.summary?.total || 0),
          points: parseInt(price?.points?.offer || 0, 10),
        };

      default:
        return 0;
    }
  };

  const handleOpenRegrasCupom = () => {
    trackResumoCompraEvent({ title: "confira-as-regras-do-cupom" });
    setRulesExpanded(true);
  };

  const handleCloseRegrasCupom = () => {
    trackResumoCompraEvent({ title: "fechar-modal" });
    setRulesExpanded(false);
  };

  const whoTab = (product, type, displayMode) => {
    const { price } = product;
    const BRL = price?.BRL;
    const SAFRA = price?.points;

    if (displayMode === "money") {
      return type === "dinheiro" && BRL?.offer > 0;
    }

    if (displayMode === "points") {
      return type === "pontos" && SAFRA?.offer > 0;
    }

    if (displayMode === "both") {
      return (
        (type === "dinheiro" && BRL?.offer > 0) ||
        (type === "pontos" && SAFRA?.offer > 0)
      );
    }

    return false;
  };

  return (
    <>
      <EmailRequiredModal
        show={showEmailRequired}
        onClose={() => setShowEmailRequired(false)}
        onRegisterEmail={() => {
          setShowEmailRequired(false);
          navigate("/loja/pj/myaccount/");
        }}
        onContinue={() => setShowEmailRequired(false)}
      />
      <InsufficientPointsModal
        show={showInsufficientPoints && displayMode !== "money"}
        onClose={() => setShowInsufficientPoints(false)}
        minPoints={minValue}
        userBalance={Math.trunc(user?.balance?.data || 0)}
      />
      <div className="wl-page">
        {couponsEnabled && (
          <CouponRulesModal open={open} setOpen={setOpen} couponRules={rules} />
        )}

        <Container>
          {isAereoCheckout ? (
            <div className="d-flex mt-3 mb-4">
              <h1
                className="mb-2 mt-4"
                style={{
                  fontWeight: 600,
                  fontSize: "20px",
                  lineHeight: "150%",
                  textAlign: "center",
                  color: whitelabel?.text_primary_color,
                  margin: 0,
                }}
              >
                Resumo da passagem
              </h1>
            </div>
          ) : (
            <TitleHead
              titleClass="mb-2 mt-4"
              label={isHotelCheckout ? "Resumo da reserva" : "Resumo da compra"}
            />
          )}

          {isHotelCheckout && envisionData && (
            <HotelSummary
              envisionData={envisionData}
              getHotelRoom={getHotelRoom}
              getHotelNights={getHotelNights}
              getHotelDailyPoints={getHotelDailyPoints}
              getHotelTaxPoints={getHotelTaxPoints}
              getHotelDailyMoney={getHotelDailyMoney}
              getHotelTaxMoney={getHotelTaxMoney}
              displayMode={displayMode}
              fator={Number(fatorHotel)}
              getCancellationPolicy={getCancellationPolicy}
              discount={getTravelDiscountBRL()}
            />
          )}

          {isAereoCheckout && envisionData && (
            <AereoSummary envisionData={envisionData} />
          )}

          {!isHotelCheckout &&
            !isAereoCheckout &&
            itemsCart &&
            Object.keys(itemsCart).map((item) => {
              const typeToFilter =
                displayMode === "points" ? "pontos" : "dinheiro";

              const brandItems = itemsCart[item].filter((product) =>
                whoTab(product, typeToFilter, displayMode),
              );
              const lastIndex = brandItems.length - 1;

              return (
                <React.Fragment key={item}>
                  <div id="productCard" className="mb-3">
                    <TitleBrand className="font-wl-500 mb-5 text-mlg color-text-dark">
                      {item}
                    </TitleBrand>
                    {brandItems.map((product, index) => (
                      <ProductRow
                        key={index}
                        item={item}
                        itemsCart={itemsCart}
                        lastIndex={lastIndex}
                        product={product}
                        index={index}
                        displayMode={displayMode}
                        checkout={dataCheckout}
                      />
                    ))}
                  </div>
                  <Line className="my-4" />
                </React.Fragment>
              );
            })}

          {!isHotelCheckout &&
            !isAereoCheckout &&
            dataCheckout.summary?.coupon &&
            dataCheckout.summary?.discount > 0 && (
              <>
                <DiscountRow>
                  <span className="discount-label">DESCONTO</span>
                  <span className="discount-value">
                    {BrlFormatCurrency(dataCheckout.summary.discount)}
                  </span>
                </DiscountRow>
              </>
            )}

          <Line />
          {isAereoCheckout ? (
            <AereoPricingSummary
              envisionData={envisionData}
              discountPoints={getTravelDiscountBRL()}
              fatorAirTicket={fatorAirTicket}
              displayMode={displayMode}
            />
          ) : (
            <Row className="font-wl-700">
              <Col>
                <p className="color-text-dark text-mg"> Total do Pedido</p>
              </Col>
              <Col className="text-end">
                {isHotelCheckout && displayMode === "money" && (
                  <p className="font-wl-700 text-lg color-text-dark">
                    {BrlFormatCurrency(getHotelTotalMoney())}
                  </p>
                )}
                {isHotelCheckout && displayMode !== "money" && (
                  <p className="font-wl-700 text-lg color-text-dark">
                    {FormatPoints(getHotelTotalPoints())} pts
                  </p>
                )}
                {!isHotelCheckout &&
                  !isAereoCheckout &&
                  displayMode === "money" && (
                    <p className="font-wl-700 text-lg color-text-dark">
                      {BrlFormatCurrency(dataCheckout.summary?.total || 0)}
                    </p>
                  )}
                {!isHotelCheckout &&
                  !isAereoCheckout &&
                  displayMode === "points" && (
                    <p className="font-wl-700 text-lg color-text-dark">
                      {totalPointsWithDiscount
                        ? `${FormatPoints(totalPointsWithDiscount)} pts`
                        : "0 pts"}
                    </p>
                  )}
                {!isHotelCheckout &&
                  !isAereoCheckout &&
                  displayMode === "both" && (
                    <p className="font-wl-700 text-lg color-text-dark">
                      {BrlFormatCurrency(dataCheckout.summary?.total || 0)}{" "}
                      <span className="text-muted">ou</span>{" "}
                      {totalPointsWithDiscount
                        ? `${FormatPoints(totalPointsWithDiscount)} pts`
                        : "0 pts"}
                    </p>
                  )}
              </Col>
            </Row>
          )}

          {displayMode !== "money" &&
            couponsEnabled && (
              <Col className="d-flex flex-column mt-5">
                <Row className="coupon-custom">
                  <Title className="color-text-dark font-wl-500 text-mlg">
                    Cupom de desconto
                  </Title>
                  <ContainerCupom>
                    <TextField
                      type="text"
                      fullWidth
                      placeholder="Insira o cupom"
                      onChange={(e) => setCoupon(e.target.value)}
                      value={coupon}
                      variant="standard"
                      disabled={isCouponApplied}
                    />
                  </ContainerCupom>
                </Row>

                <Row className="d-flex align-items-center justify-content-center">
                  {!isCouponApplied && isValidCoupon === null && (
                    <Button
                      type="button"
                      disabled={!coupon.length > 0}
                      className="btn btn-outline-wl text-xxs font-wl-700 mt-4"
                      style={{ width: 187, height: 30 }}
                      onClick={() => applyCoupon()}
                    >
                      {loadingCoupon ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                        />
                      ) : (
                        "APLICAR"
                      )}
                    </Button>
                  )}

                  {isCouponApplied && isValidCoupon === true && (
                    <Button
                      type="button"
                      className="btn btn-outline-wl text-xxs font-wl-700 mt-4"
                      style={{ width: 187, height: 30 }}
                      onClick={() => removeCoupon()}
                      disabled={loadingCoupon}
                    >
                      {loadingCoupon ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                        />
                      ) : (
                        "REMOVER"
                      )}
                    </Button>
                  )}
                </Row>

                {isValidCoupon === true && dataCheckout.summary?.coupon && (
                  <CouponSuccess>
                    <div className="coupon-title">
                      <FaRegCheckCircle size={18} />
                      <span>Cupom aplicado</span>
                    </div>

                    {dataCheckout.summary.coupon.description && (
                      <p className="coupon-message">
                        {dataCheckout.summary.coupon.description}
                      </p>
                    )}

                    {rules && (
                      <>
                        <button
                          className="coupon-rules-toggle"
                          onClick={
                            rulesExpanded
                              ? handleCloseRegrasCupom
                              : handleOpenRegrasCupom
                          }
                        >
                          <span>Confira as regras</span>
                          <span
                            className={`toggle-icon ${rulesExpanded ? "expanded" : ""}`}
                          >
                            <FaChevronDown size={14} />
                          </span>
                        </button>

                        {rulesExpanded && (
                          <div className="coupon-rules-content">{rules}</div>
                        )}
                      </>
                    )}
                  </CouponSuccess>
                )}

                {isValidCoupon === false && (
                  <>
                    <CouponError>
                      <div className="coupon-title">
                        <FaExclamationCircle size={18} />
                        <span>{errorTitle}</span>
                      </div>

                      <p className="coupon-message">{errorDescription}</p>

                      {errorCode === "COUPON_NOT_APPLICABLE" && rules && (
                        <>
                          <button
                            className="coupon-rules-toggle"
                            onClick={
                              rulesExpanded
                                ? handleCloseRegrasCupom
                                : handleOpenRegrasCupom
                            }
                          >
                            <span>Confira as regras</span>
                            <span
                              className={`toggle-icon ${rulesExpanded ? "expanded" : ""}`}
                            >
                              <FaChevronDown size={14} />
                            </span>
                          </button>

                          {rulesExpanded && (
                            <div className="coupon-rules-content">{rules}</div>
                          )}
                        </>
                      )}
                    </CouponError>

                    <Row className="d-flex align-items-center justify-content-center">
                      <Button
                        type="button"
                        className="btn btn-outline-wl text-xxs font-wl-700 mt-4"
                        style={{ width: 187 }}
                        onClick={() => {
                          setCoupon("");
                          setIsValidCoupon(null);
                          setErrorCoupon("");
                          setErrorTitle("");
                          setErrorDescription("");
                          setErrorCode("");
                          if (rulesExpanded) {
                            handleCloseRegrasCupom();
                          }
                        }}
                      >
                        TENTAR NOVAMENTE
                      </Button>
                    </Row>
                  </>
                )}
              </Col>
            )}

          <Row className="mt-4">
            {displayMode === "money" && couponsEnabled && (
              <Col className="d-flex flex-column mt-5">
                <Row className="coupon-custom">
                  <Title className="color-text-dark font-wl-500 text-mlg">
                    Cupom de desconto
                  </Title>
                  <ContainerCupom>
                    <TextField
                      type="text"
                      fullWidth
                      placeholder="Insira o cupom"
                      onChange={(e) => setCoupon(e.target.value)}
                      value={coupon}
                      variant="standard"
                      disabled={isCouponApplied}
                    />
                  </ContainerCupom>
                  {errorCoupon && (
                    <span className="text-danger text-sm">{errorCoupon}</span>
                  )}
                </Row>
                <Row className="d-flex align-items-center justify-content-center">
                  {!dataCheckout.summary?.coupon ? (
                    <Button
                      type="button"
                      disabled={!coupon.length > 0}
                      className="btn btn-outline-wl text-xxs font-wl-700 mt-4"
                      style={{ width: 187, height: 30 }}
                      onClick={() => applyCoupon()}
                    >
                      {loadingCoupon ? (
                        <span
                          className="spinner-border spinner-border-sm "
                          role="status"
                        />
                      ) : (
                        "APLICAR"
                      )}
                    </Button>
                  ) : (
                    <Button
                      type="button"
                      disabled={loadingCoupon}
                      className="btn btn-outline-wl text-xxs font-wl-700 mt-4"
                      style={{ width: 187, height: 30 }}
                      onClick={() => removeCoupon()}
                    >
                      {loadingCoupon ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                        />
                      ) : (
                        "REMOVER"
                      )}
                    </Button>
                  )}
                </Row>
              </Col>
            )}

             {(((isHotelCheckout || isAereoCheckout) && !isCashOnly) ||
              displayMode === "both" ||
              displayMode === "points") && (
              <BoxSlider>
                <div className="slider">
                  <p className="color-text-dark font-wl-600 text-mlg">
                    Formas de pagamento
                  </p>
                  <Container className="mt-4">
                    {isHotelCheckout && envisionData ? (
                      <SliderCheckoutCoupon
                        totalPoints={
                          getHotelTotalPoints() +
                          Math.ceil(fatorHotel > 0
                            ? getTravelDiscountBRL() / fatorHotel
                            : 0)
                        }
                        totalMoney={
                          getHotelTotalMoney() + getTravelDiscountBRL()
                        }
                        couponDiscount={getTravelDiscountBRL()}
                        userBalance={Math.floor(
                          Number(user?.balance?.data || 0),
                        )}
                        minPoints={minValue}
                        onChange={(values) => {
                          setPontosValue(values.pointsValue);
                          setDinheiroValue(roundCurrency(values.moneyValue));
                          setCouponMoneyToPay(values.moneyToPay || 0);
                          handlePaymentInfoChange(
                            values.moneyValue,
                            values.pointsValue,
                          );
                        }}
                        disabled={false}
                        isCouponApplied={true}
                        factor={fatorHotel > 0 ? 1 / fatorHotel : 1}
                      />
                    ) : isAereoCheckout && envisionData ? (
                      isCouponApplied && dataCheckout.summary?.coupon ? (
                        <SliderCheckoutCoupon
                          totalPoints={
                            getAereoTotalPoints() +
                            (fatorAirTicket > 0
                              ? getTravelDiscountBRL() / fatorAirTicket
                              : 0)
                          }
                          totalMoney={
                            getAereoTotalMoney() + getTravelDiscountBRL()
                          }
                          couponDiscount={getTravelDiscountBRL()}
                          userBalance={Math.floor(
                            Number(user?.balance?.data || 0),
                          )}
                          minPoints={minValue}
                          onChange={(values) => {
                            setPontosValue(values.pointsValue);
                            setDinheiroValue(roundCurrency(values.moneyValue));
                            setCouponMoneyToPay(values.moneyToPay || 0);
                            handlePaymentInfoChange(
                              values.moneyValue,
                              values.pointsValue,
                            );
                          }}
                          disabled={false}
                          isCouponApplied={true}
                          factor={fatorAirTicket > 0 ? 1 / fatorAirTicket : 1}
                        />
                      ) : (
                        <SliderCheckout
                          totalPoints={getAereoTotalPoints()}
                          totalMoney={getAereoTotalMoney()}
                          userBalance={Math.floor(
                            Number(user?.balance?.data || 0),
                          )}
                          minPoints={minValue}
                          onChange={(values) => {
                            setPontosValue(values.pointsValue);
                            setDinheiroValue(roundCurrency(values.moneyValue));
                            setSliderValue((values.sliderValue / 100) * 100);
                            handlePaymentInfoChange(
                              values.moneyValue,
                              values.pointsValue,
                            );
                          }}
                          disabled={false}
                          isAereo={true}
                          factor={fatorAirTicket > 0 ? 1 / fatorAirTicket : 1}
                        />
                      )
                    ) : isCouponApplied && dataCheckout.summary?.coupon ? (
                      <SliderCheckoutCoupon
                        totalPoints={totalPoints}
                        totalMoney={
                          parseFloat(dataCheckout.summary?.total || 0) +
                          parseFloat(dataCheckout.summary?.discount || 0)
                        }
                        couponDiscount={parseFloat(
                          dataCheckout.summary?.discount || 0,
                        )}
                        userBalance={Math.trunc(user?.balance?.data || 0)}
                        minPoints={minValue}
                        onChange={(values) => {
                          setPontosValue(values.pointsValue);
                          setDinheiroValue(roundCurrency(values.moneyValue));
                          setCouponMoneyToPay(values.moneyToPay || 0);
                          handlePaymentInfoChange(
                            values.moneyValue,
                            values.pointsValue,
                          );
                        }}
                        disabled={false}
                        isCouponApplied={true}
                        factor={fatorFrete > 0 ? 1 / fatorFrete : 1}
                      />
                    ) : (
                      <SliderCheckout
                        totalPoints={totalPoints}
                        totalMoney={parseFloat(
                          dataCheckout.summary?.total || 0,
                        )}
                        userBalance={Math.trunc(user?.balance?.data || 0)}
                        minPoints={minValue}
                        onChange={(values) => {
                          setPontosValue(values.pointsValue);
                          setDinheiroValue(roundCurrency(values.moneyValue));
                          setSliderValue((values.sliderValue / 100) * 100);
                          handlePaymentInfoChange(
                            values.moneyValue,
                            values.pointsValue,
                          );
                        }}
                        disabled={aplicouCupon}
                        factor={fatorFrete > 0 ? 1 / fatorFrete : 1}
                      />
                    )}
                  </Container>
                </div>
              </BoxSlider>
            )}
          </Row>
          {!isMoneyDisabled && (
            <Row
              className={`mt-4 mb-3 ${disableMoneyPayment || effectiveMoneyToPay <= 0 ? "disable" : ""}`}
            >
              <Col>
                <PaymentMethods
                  cards={cards}
                  installments={installments}
                  onPaymentSelect={handlePaymentSelect}
                  onDeleteCard={cardMgmt.onClickDelCard}
                  onAddCard={cardMgmt.openAddCardModal}
                  onCardSelect={handleCardSelectFromPayment}
                  onInstallmentChange={handleInstallmentFromPayment}
                  whitelabel={whitelabel}
                  paymentFlags={paymentFlags}
                />
              </Col>
            </Row>
          )}
        </Container>

        {isHotelCheckout && (
          <Container className="mt-4 mb-3">
            <Form.Check
              type="checkbox"
              id="hotel-terms-checkbox"
              checked={hotelTermsAccepted}
              onChange={(e) => setHotelTermsAccepted(e.target.checked)}
              label={
                <span className="text-xs">
                  Declaro que li o{" "}
                  <button
                    type="button"
                    onClick={() => setHotelRulesModalOpen(true)}
                    style={{
                      textDecoration: "underline",
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "inherit",
                      cursor: "pointer",
                    }}
                  >
                    regulamento
                  </button>{" "}
                  e estou de acordo com os termos das tarifas e serviços
                  oferecidos.
                </span>
              }
            />
          </Container>
        )}

        {isAereoCheckout && (
          <Container className="mt-4 mb-3">
            <Form.Check
              type="checkbox"
              id="aereo-terms-checkbox"
              checked={aereoTermsAccepted}
              onChange={(e) => setAereoTermsAccepted(e.target.checked)}
              label={
                <span className="text-xs">
                  Declaro que li o{" "}
                  <button
                    type="button"
                    onClick={() => setAereoRulesModalOpen(true)}
                    style={{
                      textDecoration: "underline",
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: "inherit",
                      cursor: "pointer",
                    }}
                  >
                    regulamento
                  </button>{" "}
                  e estou de acordo com os termos das tarifas e serviços
                  oferecidos.
                </span>
              }
            />
          </Container>
        )}

        <AddCardModal cardMgmt={cardMgmt} cards={cards} isMyAccountPage />

        <HotelTermsModal
          show={hotelRulesModalOpen}
          handleModal={() => setHotelRulesModalOpen(false)}
        />

        <AereoTermsModal
          show={aereoRulesModalOpen}
          handleModal={() => setAereoRulesModalOpen(false)}
        />

        <Footer>
          <Button
            type="button"
            onClick={() => HandleFinished()}
            className="btn-default-wl mt-5 text-xxs font-wl-700"
            disabled={
              !hasEmail ||
              (isHotelCheckout && !hotelTermsAccepted) ||
              (isAereoCheckout && !aereoTermsAccepted) ||
              (!isMoneyDisabled &&
                effectiveMoneyToPay > 0 &&
                !selectedPaymentMethod) ||
              (!isMoneyDisabled &&
                effectiveMoneyToPay > 0 &&
                selectedPaymentMethod?.type === "credit_card" &&
                !installmentsSelected)
            }
          >
            {(isHotelCheckout || isAereoCheckout) && displayMode !== "money"
              ? "FINALIZAR RESGATE"
              : "FINALIZAR COMPRA"}
          </Button>
        </Footer>
      </div>
    </>
  );
}
